import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';
import { switchMap, map, tap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { IDeviceCategory } from '../../devices/models/device-category';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import { deviceCategoriesSelector } from 'src/app/stores/global/device-categories/selectors';
import { DeviceService } from '../../devices/services/device.service';

export interface DeviceCategoryState {
  category: IDeviceCategory | null;
}

@Injectable()
export class DeviceCategoryStore extends ComponentStore<DeviceCategoryState> {

  // Initial state
  constructor(private store: Store<AppStateInterface>, private deviceService: DeviceService) {
    super({ category: null });
  }

  // Selector for the current category
  readonly selectedCategory$: Observable<IDeviceCategory | null> = this.select(state => state.category);

  // Effect to load category by ID from global store
  readonly getCategoryById = this.effect<string>(categoryId$ =>
    categoryId$.pipe(
      switchMap(categoryId =>
        this.deviceService.getDeviceCategoryById(categoryId).pipe(
          tap(category => this.patchState({ category }))
        )
      )
    )
  );
}
